import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
// import Swiper core and required modules
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { VimeoPlayerComponent } from '@df/ui/display/media/vimeo-player.component';
import { YoutubePlayerComponent } from '@df/ui/display/media/youtube-player.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { defaultImage } from 'projects/app-default/src/app/icms.config';
import SwiperCore, { Navigation, Scrollbar } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { getCmsContentFieldConfig } from '../../../../../cms/components/components.config';
import { ICmsComponentContentData, ICmsContentVariant, ICmsContentVideoProvider } from '../../../../../cms/components/components.interface';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
// install Swiper modules
SwiperCore.use([Scrollbar, Navigation]);
interface ICategoryCarouselQuickLink extends ICmsComponentContentData {
    image: string;
    title: string;
    url: string;
}
interface IPageComponenCategoryCarouselData extends NICmsContentComponent.IData, ICmsComponentContentData {
    title: string;
    quicklinks: ICategoryCarouselQuickLink[];
}
@Component({
    selector: 'page-component-category-carousel',
    templateUrl: './category-carousel.html',
    standalone: true,
    imports: [ICmsClientModule, SwiperModule, HrefComponent, ShellComponent, ImageModule, VimeoPlayerComponent, YoutubePlayerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
@ICmsComponent<PageComponentCategoryCarouselComponent>({
    id: 'category-carousel',
    name: 'Quicklinks category carousel ',
    tags: ['category', 'carousel'],
    fields: [
        {
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
            default: 'Horse Wear Collections',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'quicklinks',
            title: 'Quick Links',
            itemName: 'Link',
            itemNameField: 'text',
            fields: [
                ...getCmsContentFieldConfig('image'),
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title copy',
                    default: 'Title',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'Link',
                    required: true
                }
            ],
            default: [
                {
                    title: 'Headcollars',
                    url: '/',
                    image: defaultImage
                },
                {
                    title: 'Boots',
                    url: '/',
                    image: defaultImage
                },
                {
                    title: 'Fly Hoods',
                    url: '/',
                    image: defaultImage
                },
                {
                    title: 'Saddlery & Tack',
                    url: '/',
                    image: defaultImage
                },
                {
                    title: 'Rugs',
                    url: '/',
                    image: defaultImage
                },
                {
                    title: 'Fly Masks',
                    url: '/',
                    image: defaultImage
                },
                {
                    title: 'Polo Bandages',
                    url: '/',
                    image: defaultImage
                },
                {
                    title: 'Grooming',
                    url: '/',
                    image: defaultImage
                },
                {
                    title: 'Luggage',
                    url: '/',
                    image: defaultImage
                }
            ]
        }
    ]
})
export class PageComponentCategoryCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponenCategoryCarouselData;
    contentVariant = ICmsContentVariant;
    contentVideoProvider = ICmsContentVideoProvider;
}
